import { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  type ThemeThunkDispatch,
  subscribeToThemes,
} from "@dashboard/store/actions/themeActions";

import { useRestaurant } from "./useRestaurant";

/**
 * Keeps the Redux theme state in sync with Firestore for the selected
 * restaurant while the calling component is mounted. Mounted by the restaurant
 * management layout, because the sidebar renders the default theme's logo on
 * every page.
 */
export const useSyncThemes = () => {
  const dispatch: ThemeThunkDispatch = useDispatch();
  const { uuid } = useRestaurant();

  useEffect(() => dispatch(subscribeToThemes(uuid)), [dispatch, uuid]);
};
